import { UnifiedCompareState, CompareActions } from '../../types';
import { transformCompareListsToAPI } from '../../utils';
import { ApiCancelToken } from 'api';
import { put } from 'redux-saga/effects';
import { PRODUCTS_COMPARE_MANAGE } from '../../actions';

export type ManageProductAction = {
  payload: {
    action: CompareActions;
    productId: string;
    groupName?: string;
    familyId?: string;
    withData?: boolean;
    productIds?: string[];
  };
};

export type SagaParams = {
  customerId: string;
  host: string;
  abortController: { token: ApiCancelToken };
  currentLists: ReturnType<typeof transformCompareListsToAPI>;
  productId: string;
  groupId: string;
};

export const validateActionPayload = (payload: ManageProductAction['payload']) =>
  payload && Object.values(CompareActions).includes(payload.action);

export function updateCompareState(
  currentState: UnifiedCompareState,
  groupId: string,
  updates: Partial<UnifiedCompareState[string]>,
): UnifiedCompareState {
  const existingGroup = currentState[groupId];
  return {
    ...currentState,
    [groupId]: {
      ...existingGroup,
      ...updates,
    },
  };
}

export function removeGroupFromState(
  currentState: UnifiedCompareState,
  groupId: string,
): UnifiedCompareState {
  const { [groupId]: removedGroup, ...restState } = currentState;
  return restState;
}

export function applyProductChangesToGroup(
  currentProductIds: string[],
  action: CompareActions,
  productId: string,
  productIds?: string[],
): string[] {
  const productIdsSet = new Set(currentProductIds);

  switch (action) {
    case CompareActions.ADD:
      if (productIds) {
        productIds.forEach((id) => productIdsSet.add(id));
        break;
      }
      productIdsSet.add(productId);
      break;
    case CompareActions.DELETE:
      if (productId) {
        productIdsSet.delete(productId);
      }
      break;
    case CompareActions.DELETE_GROUP:
      productIdsSet.clear();
      break;
    default:
      break;
  }

  return Array.from(productIdsSet);
}

export const isDataSyncError = (
  error:
    | {
        response?: { status?: number };
        status?: number;
        message?: string;
      }
    | null
    | undefined,
): boolean => {
  if (!error) return false;

  const status = error?.response?.status || error?.status;
  const message = error?.message || '';

  return status === 409 || message.includes('409');
};

/**
 * NOTE: Обрабатывает ошибки синхронизации данных (409 Conflict),
 * запрашивая актуальные данные с сервера.
 * Такие ошибки указывают на рассинхронизацию данных между клиентом и сервером
 */
export function* handleBadRequestError(): Generator {
  yield put(
    PRODUCTS_COMPARE_MANAGE.request({
      groupId: '',
      action: CompareActions.LOAD,
    }),
  );
}
